import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { schema } from "./validations";
import { getRequiredFields } from "@/lib/utils";

const usePaymentBlockDialog = ({ defaultValues, onSavePaymentBlock }: any) => {
  const form = useForm<any>({
    defaultValues: { ...defaultValues },
    resolver: zodResolver(schema),
  });

  const requiredFields = getRequiredFields(schema);

  const onSubmit = (data: any) => {
    onSavePaymentBlock(data);
  };

  return {
    form,
    onSubmit,
    requiredFields,
  };
};

export default usePaymentBlockDialog;
